module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('user-info', {
    attrs: {
      "userInformationUrl": _vm.userInformationUrl,
      "revokeUserUrl": _vm.revokeUserUrl,
      "restoreUserUrl": _vm.restoreUserUrl,
      "updateUserPermissionsUrl": _vm.updateUserPermissionsUrl,
      "globalUser": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b9ce6cd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/user-administration/user-management/user-information/UserInformation.vue
// module id = 772
// module chunks = 1